import { Component, OnInit } from '@angular/core';
import { HolidayService } from 'src/app/admin/servicies/holiday.service';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.sass'],
  standalone: false
})
export class SettingsComponent implements OnInit {
  title = 'Settings';
  useremail: string;
  isBoardingDisplay: boolean = false;

  constructor(private holidayService: HolidayService, private webStorageService: WebStorageService) {}

  ngOnInit() {
    this.holidayService._setTabIndex(0);
    const currentUserToken = this.webStorageService.getCurrentUserToken();
    const currentUserAuthToken = this.webStorageService.getCurrentUserAuthToken();
    if (currentUserToken && currentUserAuthToken.token) {
      this.useremail = currentUserToken.userEmail;
      const allowedEmails = [
        'himanshu.zalte@analytix.com',
        'tushar.modak@analytix.com',
        'jasdeep.mathadu@analytix.com',
        'prashant.sorathia@analytix.com',
        'manoj.patel@analytix.com'
      ];
      if (allowedEmails.includes(this.useremail)) {
        this.isBoardingDisplay = true;
      }
    }
  }
}
